import jwtDecode from "jwt-decode"
import storage from "./storage"
import { U_ACS_TOKEN_IDENTIFIER } from "@/consts"

export const getToken = () => {
    const { href } = window.location
    const queryString =
        href.indexOf("?") === -1 ? "" : href.slice(href.indexOf("?") + 1)
    const queryParams = new URLSearchParams(queryString)

    return queryParams.has("acs_token")
        ? decodeURIComponent(queryParams.get("acs_token") as string)
        : storage.getItem(U_ACS_TOKEN_IDENTIFIER)
}
export const hasToken = () => !!getToken()
export const removeToken = () =>
    hasToken() && storage.removeItem(U_ACS_TOKEN_IDENTIFIER)
export const setToken = (token: string) =>
    storage.setItem(U_ACS_TOKEN_IDENTIFIER, token)
export const isTokenExpired = () => {
    if (!hasToken()) return true

    const jwt = jwtDecode(getToken()) as any
    if (isNaN(+jwt.exp)) return true

    return +jwt.exp * 1000 <= Date.now()
}
